export default "__VITE_ASSET__qLPElNtF__"